import { useState } from 'react';
import axios from 'axios';
import { Message } from '../types';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.claudevietnam.com';

export function useChat(token: string | null) {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendMessage = async (content: string, purchaseId: string) => {
    if (!token) {
      setError('Not authenticated');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const userMsg: Message = {
        id: Date.now().toString(),
        role: 'user',
        content,
        tokens_used: 0,
        created_at: new Date().toISOString(),
      };
      setMessages(prev => [...prev, userMsg]);

      const response = await axios.post(
        `${API_BASE}/api/chat`,
        {
          message: content,
          purchase_id: purchaseId,
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const assistantMsg: Message = {
        id: (Date.now() + 1).toString(),
        role: 'assistant',
        content: response.data.response,
        tokens_used: response.data.tokens_used,
        created_at: new Date().toISOString(),
      };
      setMessages(prev => [...prev, assistantMsg]);

      return response.data;
    } catch (err: any) {
      const msg = err.response?.data?.error || 'Failed to send message';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const clearMessages = () => {
    setMessages([]);
  };

  return { messages, loading, error, sendMessage, clearMessages };
}
